export default __webpack_public_path__ + "static/media/scribble-white.d0d69cd9.svg";